const API_URL = '/external-service-connector'

export const state = () => ({})

export const getters = {}

export const mutations = {}

export const actions = {
  async fetch({ commit }, external_service_connector_id) {
    let { data } = await useApi(`${API_URL}/${external_service_connector_id}`)
    return data.value
  },
  async update({ commit }, external_service_connector) {
    let { data } = await useApi(`${API_URL}/${external_service_connector.id}`, {
      method: 'put',
      body: external_service_connector,
    })

    return data.value
  },
  async delete({ commit }, external_service_connector_id) {
    await useApi(`${API_URL}/${external_service_connector_id}`, { method: 'delete' })
  },
}
